import {useSnackBar} from "@hooks/alert/useSnackBar";
import {buildErrorsMessages} from "@ui/errors/helpers/helpers";
import {useMutation, useQuery, useQueryClient} from "@tanstack/react-query";
import {useTranslation} from "react-i18next";
import {
    QUERY_KEY_TASK_TEMPLATES_SINGLE_VOYAGES
} from "@containers/singleVoyage/taskTemplate/queryHooks/constants/queryKey";
import {
    getTasksTemplateSingleVoyage,
    saveTaskTemplateSingleVoyage
} from "@containers/singleVoyage/taskTemplate/api/api";
import {useShowError} from "@hooks/useShowError/useShowError";
import {IPropsGetTasksTemplateSingleVoyage} from "@containers/singleVoyage/taskTemplate/types";
import {refetchSingleVoyages} from "@containers/singleVoyage/refetchSingleVoyages/refetchSingleVoyages";


export const useSaveTasksTemplateSingleVoyageQuery = ({
                                                          onSuccess
                                                      }: {
    onSuccess?: () => void
} = {}) => {
    const client = useQueryClient();
    const {setSnackBar} = useSnackBar()

    const {t} = useTranslation()

    return useMutation({
        mutationFn: saveTaskTemplateSingleVoyage,
        onSuccess: () => {
            client.invalidateQueries({queryKey: [QUERY_KEY_TASK_TEMPLATES_SINGLE_VOYAGES]});
            refetchSingleVoyages()
            setSnackBar({
                title: t('base.successSaveMessage'),
                variant: 'info'
            })
            onSuccess && onSuccess()
        },
        onError: (e) => {
            const message = buildErrorsMessages(e)
            setSnackBar({
                message,
                variant: 'error'
            })
        }
    });
}


export const useGetTasksTemplateSingleVoyageQuery = ({
                                                         params,
                                                         enabled
                                                     }: {
    params: IPropsGetTasksTemplateSingleVoyage,
    enabled?: boolean
}) => {
    const {onShowError} = useShowError()

    return useQuery({
        queryFn: () => getTasksTemplateSingleVoyage(params, onShowError),
        queryKey: [QUERY_KEY_TASK_TEMPLATES_SINGLE_VOYAGES, params?.accountId],
        staleTime: 1000 * 60 * 30,
        enabled: (typeof enabled !== 'undefined' ? enabled : true) && !!params?.accountId,
    });
}
